<script>
  export let idUnico = 'glossariohint';
  export let content;

  content = content.replace('marrom', '<span class ="marrom">marrom</span>');
</script>

<div class="container">
  <div class="box">
    <p>
      {@html content}
    </p>
  </div>
</div>

<style>
  .box {
    margin-left: 29px;
    margin-top: -1.5rem;
  }

  .box :global(.marrom) {
    color: #fff;
    font-weight: 700;
    background: var(--MARROM);
  }

  @media (max-width: 767px) {
    .box {
      margin-left: 15px;
    }
  }
</style>
